// Spis treści strony prawnej — JEDNA lista, dwa kształty (artboardy 03a i 03b).
//
// 1440: kolumna 240 px przyklejona po lewej, bez numerów — numer paragrafu stoi już
// przy nagłówku sekcji, więc w spisie byłby drugim zapisem tej samej rzeczy.
// 390: przycisk 52 px „Na tej stronie · N sekcji" otwiera arkusz z numerami (tam
// nagłówków nie widać, więc numer jest jedynym kotwiczeniem), zamykany wyborem
// pozycji, stuknięciem w tło, „wstecz" i pociągnięciem za uchwyt.
//
// Arkusz i lista czytają TĘ SAMĄ tablicę sekcji: spis, który rozjeżdża się z
// dokumentem, jest gorszy niż brak spisu.

import { useState } from 'react'
import Icon from '../Icon'
import { BottomSheet } from '../../ds/feedback/BottomSheet'
import { useT } from '../../lib/i18n'

export interface TocItem {
  id: string
  /** Numer sekcji (paragrafu) — pokazywany tylko w arkuszu na 390. */
  num?: string
  label: string
}

export default function DocToc({ items, activeId, onSelect, meta }: {
  items: TocItem[]
  activeId?: string | null
  onSelect: (id: string) => void
  /** Zdanie pod nazwą przycisku na 390, np. „16 sekcji". */
  meta?: string
}) {
  const t = useT()
  const [sheet, setSheet] = useState(false)
  const label = t('legal.toc.label')

  return (
    <>
      <nav className="mp-cats mp-cats-toc" aria-label={label}>
        <small>{label}</small>
        {items.map((item) => (
          <a key={item.id} href={`#${item.id}`}
             className={`mp-nav-link${activeId === item.id ? ' is-active' : ''}`}
             aria-current={activeId === item.id ? 'true' : undefined}
             onClick={(e) => { e.preventDefault(); onSelect(item.id) }}>
            {item.label}
          </a>
        ))}
      </nav>

      <button type="button" className="mp-toc-btn" aria-haspopup="dialog" onClick={() => setSheet(true)}>
        {label}
        {meta ? <small>{meta}</small> : null}
        <Icon name="ChevronDown" size={18} />
      </button>

      {sheet && (
        <BottomSheet title={label} onClose={() => setSheet(false)}>
          <div className="mp-toc-list">
            {items.map((item) => (
              <button key={item.id} type="button"
                      className={`mp-toc-row${activeId === item.id ? ' is-active' : ''}`}
                      onClick={() => { setSheet(false); onSelect(item.id) }}>
                {item.num ? <span className="mp-toc-num">{item.num}</span> : null}
                <span>{item.label}</span>
              </button>
            ))}
          </div>
        </BottomSheet>
      )}
    </>
  )
}
